// SLA thresholds for the Kanban / lead cards.
// Number of days in the current stage before a card gets flagged.
export const SLA_WARNING_DAYS = 5;
export const SLA_CRITICAL_DAYS = 10;

/** Return whole days since the timestamp (ISO string). */
export const daysSince = (iso) => {
  if (!iso) return 0;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 0;
  const diffMs = Date.now() - t;
  return Math.max(0, Math.floor(diffMs / (24 * 60 * 60 * 1000)));
};

/** Return SLA level for a lead: "ok" | "warn" | "critical" plus days. */
export const slaLevelFor = (lead) => {
  const stamp = lead?.stage_entered_at || lead?.updated_at || lead?.created_at || "";
  const days = daysSince(stamp);
  if (["Won", "Lost"].includes(lead?.status)) return { level: "ok", days };
  if (days >= SLA_CRITICAL_DAYS) return { level: "critical", days };
  if (days >= SLA_WARNING_DAYS) return { level: "warn", days };
  return { level: "ok", days };
};
